import { ReactNode } from 'react';
import classNames from 'classnames';

import { Table } from 'components/Display/Table/Table';
import { Button } from 'components/Form/Button';

type EmptyStateProps = {
  children: ReactNode;
  cols: number;
  background?: 'white' | 'gray';
  cta?: Omit<Parameters<typeof Button>[0], 'variant' | 'className'>;
};

export const EmptyState = ({ children, cols, cta, background = 'white' }: EmptyStateProps) => {
  return (
    <Table.Row withBottomBorder={background === 'white'}>
      <Table.Cell colSpan={cols} className="!p-0">
        <div
          className={classNames(
            'text-sm !text-gray-500 text-center py-6 font-normal',
            background === 'gray' ? 'bg-gray-50' : undefined,
          )}
        >
          <div>{children}</div>
          {cta ? <Button {...cta} variant="secondary" className="mt-6" /> : null}
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
